import { Injectable } from '@angular/core';
import { ExportExcelResponse } from '@thehubz/client/data-access-api';
import { BehaviorSubject, Observable } from 'rxjs';
import { ClientNotificationHandlerService } from '../errors/client-notification-handler.service';
import { CoreDownloadService } from './core-download.service';

export class BackgroundProcess {
  readonly timestamp: number;

  constructor(public description: string, public icon = 'upload_file') {
    this.timestamp = new Date().getTime();
  }
}

@Injectable({ providedIn: 'root' })
export class BackgroundProcessService {
  backgroundProcess$ = new BehaviorSubject<BackgroundProcess[]>([]);

  constructor(private notifications: ClientNotificationHandlerService, private coreDownloadService: CoreDownloadService) {}

  addExportProcess(process$: Observable<ExportExcelResponse>, description: string) {
    this.notifications.successNotification($localize`Export is processing. Download will start automatically`, 'info');
    const process = new BackgroundProcess(`Export ${description}`);
    this.backgroundProcess$.next(this.backgroundProcess$.value.concat(process));

    process$.subscribe({
      next: (res) => {
        if (res) {
          if (res.url && res.filename) {
            this.coreDownloadService.downloadSignedUrl(res.url, res.filename);
          } else {
            console.error(res);
            this.notifications.errorNotification($localize`Something went wrong with the export. Please try again and contact support if the problem persists`);
          }
        }
        this.removeProcess(process);
      },
      error: (err) => {
        this.notifications.errorNotification(err);
        this.removeProcess(process);
      },
    });
  }

  private removeProcess(process: BackgroundProcess) {
    const processes = this.backgroundProcess$.value.filter((p) => p.timestamp !== process.timestamp);
    this.backgroundProcess$.next(processes);
  }
}
